import Api from 'services/Api';
import Vue from 'vue';

export const mutationTypes = {
    UPDATE_VALUE: 'UPDATE_VALUE',
};

// Initial State
const state = {
    table: [],
    awards: [],
    currentRpi: []
};

// Getters
const getters = {
    getAll: state => state,
    value: state => key => state[key],
};

// Actions
const actions = {
    loadTable({state, commit}) {
        return Api.calculators.monetary.pslaTable().then(
            returnData => {
                commit(mutationTypes.UPDATE_VALUE, {key: 'table', value: returnData});
                return returnData;
            }
        );
    },
    loadAwards({state, commit}) {
        return Api.calculators.monetary.pslaAwards().then(
            returnData => {
                commit(mutationTypes.UPDATE_VALUE, {key: 'awards', value: returnData});
                return returnData;
            }
        );
    },
    loadCurrentRpi({state, commit}) {
        return Api.calculators.monetary.rpiCurrent().then(
            returnData => {
                commit(mutationTypes.UPDATE_VALUE, {key: 'currentRpi', value: returnData});
                return returnData;
            }
        );
    },
};

// Mutations
const mutations = {
    [mutationTypes.UPDATE_VALUE](state, {key, value}) {
        Vue.set(state, key, value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/psla.js